<template>
  <div>
    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogo" largura="700px" titulo="Categoria" dividers persistent
        @abrir="$refs.formulario.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12" sm="8">
              <v-text-field 
                v-model="categoria.descricao" 
                filled 
                dense 
                ref="nome" 
                label="Descrição"
                maxlength="150"
                counter="150"
                :rules="[regras.campoObrigatorio]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field 
                v-model="categoria.cor" 
                filled 
                dense 
                ref="cor" 
                label="Cor"
                readonly
                :color="categoria.cor"
              >
                <template v-slot:append>
                  <v-icon :color="categoria.cor" @click="abrirEscolherCor">mdi-palette</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="fechar" :disabled="salvando">Cancelar</v-btn>
          <v-btn color="primary" depressed ref="btnConfirmar" :loading="salvando" :disabled="!form_valido"
            @click="confirmar">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
    <escolher-cor ref="dialogoEscolherCor" @input="atualizarCor"></escolher-cor>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import * as regras from "@/app/helpers/validacoes";
import EscolherCor from "./EscolherCor.vue";

export default {
  name: "CategoriasForm",

  components: { EscolherCor },

  data() {
    return {
      excluindo: false,
      salvando: false,
      form_valido: true,
      regras: { ...regras },
    };
  },

  computed: {
    ...mapState({
      loading: (state) => state.loading,
      categoria_atual: (state) => state.categorias.categoria_atual,
    }),

    ...mapState("categoriascontas", ["categoria", 'categorias']),

    categorias_count() {
      return this.categorias.length;
    },
  },

  methods: {
    ...mapActions("categoriascontas", [
      "abrir",
      "atualizar",
      "salvar",
    ]),

    abrir() {
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.formulario.resetValidation();
      this.$refs.dialogo.fechar();
    },

    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.categoria.id) {
          await this.atualizar(this.categoria);
          this.$eventbus.notificar("Categoria atualizada.");
        } else {
          await this.salvar(this.categoria);
          this.$eventbus.notificar("Categoria cadastrada com sucesso.");
        }

        this.fechar();
      } catch (error) {
        this.$eventbus.erroSistema(
          "Não foi possível salvar esta categoria. Verifique os dados preenchidos."
        );
      } finally {
        this.salvando = false;
      }
    },

    abrirEscolherCor() {
      this.$refs.dialogoEscolherCor.abrir();
    },

    atualizarCor(cor) {
      this.categoria.cor = cor;
    },

  },
};
</script>

<style scoped></style>
